<template>
    <div class="main-wrapper">
        <layout-header></layout-header>

        <ConditionBanner :conditions="conditionData" :name="bannerTitle" />

        <section class="facility-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 m-auto">
                        <div class="section-header text-center">
                            <h2>Ezetimibe/Simvastatin</h2>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <h1 class="title">About</h1>
                        <div class="card">
                            <p>
                                Ezetimibe/simvastatin is a combination medication used to treat high cholesterol levels in
                                the blood. It is composed of two active ingredients: ezetimibe and simvastatin. Ezetimibe
                                belongs to a class of drugs known as cholesterol absorption inhibitors, while simvastatin is
                                a statin medication.
                            </p>
                        </div>
                        <h1 class="title">How it works</h1>
                        <div class="card">
                            <h3>Cholesterol absorption inhibition</h3>
                            <p>
                                Ezetimibe works by blocking the absorption of cholesterol from the intestine into the
                                bloodstream. It inhibits a protein called NPC1L1 (Niemann-Pick C1-Like 1 protein), which is
                                responsible for transporting cholesterol across the intestinal wall. By blocking this
                                protein, ezetimibe reduces the amount of cholesterol absorbed from dietary sources and bile
                                in the intestines, leading to lower levels of cholesterol in the blood.
                            </p>
                            <h3>HMG-CoA reductase inhibition</h3>
                            <p>
                                Simvastatin works by inhibiting the enzyme HMG-CoA reductase, which plays a key role in the
                                production of cholesterol in the liver. By blocking this enzyme, simvastatin reduces the
                                synthesis of cholesterol in the liver, leading to lower levels of cholesterol in the
                                bloodstream.
                            </p>
                            <p>
                                By combining ezetimibe and simvastatin, this medication addresses both the absorption of
                                cholesterol from the diet and the production of cholesterol in the liver, resulting in
                                greater reductions in cholesterol levels compared to either drug alone.
                            </p>
                            <h4>Consumption</h4>
                            <p>
                                Ezetimibe/simvastatin is typically taken orally in the form of tablets. The dosage and
                                duration of treatment depend on the individual's cholesterol levels, cardiovascular risk
                                factors, and response to the medication.
                            </p>
                        </div>
                        <h1 class="title">Possible Side Effects</h1>
                        <div class="card">
                            <ul>
                                <li>
                                    <h4>Muscle pain or weakness</h4>
                                    Some people may experience muscle-related symptoms such as muscle pain, weakness, or
                                    tenderness. In rare cases, severe muscle breakdown (rhabdomyolysis) can occur, which can
                                    lead to kidney damage.
                                </li>
                                <li>
                                    <h4>Gastrointestinal symptoms</h4>
                                    Common side effects may include nausea, vomiting, diarrhea, or stomach discomfort.
                                </li>
                                <li>
                                    <h4>Liver abnormalities</h4>
                                    Ezetimibe/simvastatin can cause elevations in liver enzymes, indicating potential liver
                                    inflammation or damage. Liver function tests are typically monitored periodically during
                                    treatment with ezetimibe/simvastatin to detect any abnormalities.
                                </li>
                                <li>
                                    <h4>Headache</h4>
                                    Headaches are a relatively common side effect, though usually mild.
                                </li>
                                <li>
                                    <h4>Increased blood sugar levels</h4>
                                    Some individuals may experience an increase in blood sugar levels while taking
                                    ezetimibe/simvastatin, particularly in those who are already at risk for diabetes.
                                </li>
                                <li>
                                    <h4>Increased risk of tendon rupture</h4>
                                    There have been reports of an increased risk of tendon rupture, particularly in
                                    individuals taking statin medications like simvastatin.
                                </li>
                            </ul>
                            <p>
                                It's essential to use ezetimibe/simvastatin as directed by a healthcare professional and to
                                follow up regularly for monitoring of cholesterol levels and potential side effects. If you
                                experience any concerning symptoms or side effects while taking ezetimibe/simvastatin, it's
                                crucial to seek medical attention promptly. Additionally, it's important to inform your
                                healthcare provider about any other medications, supplements, or herbal products you are
                                taking, as ezetimibe/simvastatin may interact with certain medications.
                            </p>
                        </div>
                        <hr>
                        <div class=" d-flex justify-content-center">
                            <div class="search-box text-center mt-3">
                                <div class="form-group mb-2"><a href="/app/patient/register" class="">
                                        <button class="btn btn-info btn-block">SIGN UP TO GET PRESCRIBED!</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </section>

        <layout-footer></layout-footer>
    </div>
</template>

<script>
import medicinesbannerData from './assets/medicinesbannerData'
export default {
    ...medicinesbannerData
}
</script>

<style src="../../assets/css/conditionsfontstyles.css"></style>